export function observeHeightVars(): void {
	const ro = new ResizeObserver((entries: ResizeObserverEntry[]) => {
		entries.forEach((entry) => {
			// ResizeObserverEntry.target は Element 型なので HTMLElement に絞る
			if (!(entry.target instanceof HTMLElement)) return;

			const el = entry.target;
			const cssVar = el.dataset.heightVar;
			if (!cssVar) return;

			document.documentElement.style.setProperty(
				cssVar,
				`${el.offsetHeight}px`
			);
		});
	});

	// 取得要素を HTMLElement として扱う
	const elements = document.querySelectorAll<HTMLElement>('.js-get-height');

	elements.forEach((el) => {
		const cssVar = el.dataset.heightVar;
		if (!cssVar) return;

		// 初期セット
		document.documentElement.style.setProperty(
			cssVar,
			`${el.offsetHeight}px`
		);

		// 監視開始
		ro.observe(el);
	});
}
